var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'mobile_nav_indise',
    _vm.cut ? 'light' : 'dark',
    _vm.move ? 'move_top' : 'move_back',
  ],attrs:{"id":"mobile_nav_indise"}},[_c('img',{staticStyle:{"width":"1.4rem"},attrs:{"src":_vm.logo,"alt":""}}),_c('div',{style:({color:_vm.color,fontWeight:'700'})},[_vm._v("鼎函科技")]),_c('div',{staticClass:"img_con",on:{"click":function($event){return _vm.getMenu()}}},[_c('img',{staticStyle:{"width":"1.5rem"},attrs:{"src":_vm.menu,"alt":""},on:{"click":function($event){return _vm.getMenu()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }